// src/pages/ProductScreen.jsx

import {
    Box,
    Button,
    Container,
    Group,
    Paper,
    Stack,
    Text,
    Title,
    Grid,
    Badge,
    SimpleGrid,
    Image,
    List,
    ThemeIcon,
} from "@mantine/core";

export default function ProductScreen() {

const features = [
  {
    title: "QR-Based Booking",
    desc: "Every rental shop gets a unique QR code that customers can scan to start the booking request.",
    image: "/rentalflow/qr.png",
  },

  {
    title: "Customer Booking Form",
    desc: "Customers can enter their details, choose dates, select vehicle type, and upload required documents.",
    image: "/rentalflow/customerform.png",
  },

  {
    title: "Booking Management",
    desc: "Rental owners can view all booking requests in one organized screen instead of managing them manually.",
    image: "/rentalflow/bookings.png",
  },

  {
    title: "Booking Details",
    desc: "Open each booking to see customer information, pickup/drop timing, documents, and assignment details.",
    image: "/rentalflow/bookingdetails.png",
  },

  {
    title: "Pre-Ride Vehicle Photos",
    desc: "Upload vehicle condition photos before handing over the vehicle to reduce damage disputes later.",
    image: "/rentalflow/vehicle-pre-ride.png",
  },

  {
    title: "Digital Dashboard",
    desc: "View shop activity, bookings, customers, vehicles, and rental flow from one clean dashboard.",
    image: "/rentalflow/dashboard.png",
  },

    {
    title: "Fleet Management",
    desc: "Add and manage bikes, cars, vehicle categories, and availability from the fleet section.",
    image: "/rentalflow/fleets.png",
  },
];




    return (
        <Box
            style={{
                minHeight: "100vh",
                backgroundColor: "#f0ede8",
            }}
        >

        
            <Box id="features" py={40} style={{ backgroundColor: "#111" }}>
                <Container size="lg">
<Stack align="center" mb={60}>

  <Badge color="orange" variant="light">
    RentalFlow Product Walkthrough
  </Badge>

  <Title
    order={2}
    fw={900}
    c="white"
    ta="center"
    maw={900}
  >
    Explore how RentalFlow manages the complete vehicle rental process
  </Title>



</Stack>

                    <Stack gap={28}>
                        {features.map((item, index) => (
                            <Paper
                                key={item.title}
                                radius={28}
                                p={{ base: 20, md: 28 }}
                                bg="#1b1b1b"
                                style={{
                                    border: "1px solid #2a2a2a",
                                }}
                            >
                                <Grid align="center" gutter={30}>
                                    {/* Image column */}
                                    <Grid.Col
                                        span={{ base: 12, md: 6 }}
                                        order={{ base: 2, md: index % 2 === 0 ? 1 : 2 }}
                                    >
                                        <Image
                                            src={item.image}
                                            fallbackSrc={`https://placehold.co/900x650/222222/f24c1a?text=${encodeURIComponent(
                                                item.title
                                            )}`}
                                            alt={item.title}
                                            radius={22}
                                        />
                                    </Grid.Col>

                                    {/* Text column */}
                                    <Grid.Col
                                        span={{ base: 12, md: 6 }}
                                        order={{ base: 1, md: index % 2 === 0 ? 2 : 1 }}
                                    >
                                        <Stack gap={14}>
                                            <Badge
                                                color="orange"
                                                variant="filled"
                                                radius="xl"
                                                w="fit-content"
                                            >
                                                {String(index + 1).padStart(2, "0")}
                                            </Badge>

                                            <Title order={3} c="white" fw={900}>
                                                {item.title}
                                            </Title>

                                            <Text c="#bdbdbd" size="md" style={{ lineHeight: 1.8 }}>
                                                {item.desc}
                                            </Text>
                                        </Stack>
                                    </Grid.Col>
                                </Grid>
                            </Paper>
                        ))}
                    </Stack>
                </Container>
            </Box>

          
            <Box py={70}>
                <Container size="md">
                    <Paper
                        radius={28}
                        p={{ base: 28, md: 42 }}
                        bg="white"
                        shadow="xs"
                        style={{
                            border: "1px solid #ece7df",
                        }}
                    >
                        <Stack align="center" gap={14}>
                            <Badge color="orange" variant="light">
                                RentalFlow
                            </Badge>

                            <Title order={2} fw={900} c="#1a1a1a" ta="center">
                                Ride More. Earn More.
                            </Title>

                            <Text
                                ta="center"
                                c="#666"
                                maw={650}
                                style={{ lineHeight: 1.8 }}
                            >
                                Give your rental shop a digital booking system
                                that helps you reduce paperwork, verify
                                customers, manage bookings, organize vehicles,
                                and protect your business with photo records.
                            </Text>

                            <Group mt={12} gap={18} justify="center">
                                <Button
                                    component="a"
                                    href="https://instagram.com/rentalflow.in"
                                    target="_blank"
                                    radius={14}
                                    size="md"
                                    style={{
                                        backgroundColor: "#f24c1a",
                                        fontWeight: 700,
                                    }}
                                >
                                    Partner With RentalFlow
                                </Button>

                                <Button
                                    component="a"
                                    href="https://rentalflow.in"
                                    target="_blank"
                                    radius={14}
                                    size="md"
                                    variant="outline"
                                    color="orange"
                                >
                                    Visit rentalflow.in
                                </Button>
                            </Group>

                            <Group mt={12} gap={18} justify="center">
                                <Text
                                    component="a"
                                    href="https://instagram.com/rentalflow.in"
                                    target="_blank"
                                    fw={700}
                                    c="#f24c1a"
                                    style={{ textDecoration: "none" }}
                                >
                                    Instagram: @rentalflow.in
                                </Text>
                                <Text
                                    component="a"
                                    href="tel:+918172818877"
                                    fw={700}
                                    c="#f24c1a"
                                    style={{ textDecoration: "none" }}
                                >
                                    Contact: 8172818877
                                </Text>

                                <Text
                                    component="a"
                                    href="https://rentalflow.in"
                                    target="_blank"
                                    fw={700}
                                    c="#f24c1a"
                                    style={{ textDecoration: "none" }}
                                >
                                    rentalflow.in
                                </Text>
                            </Group>
                            <Group mt={6} gap={18} justify="center">
                            <Text
                                component="a"
                                href="/policy"
                                size="sm"
                                c="#777"
                                style={{ textDecoration: "none" }}
                            >
                                Privacy Policy
                            </Text>

                            <Text
                                component="a"
                                href="/terms"
                                size="sm"
                                c="#777"
                                style={{ textDecoration: "none" }}
                            >
                                Terms & Conditions
                            </Text>
                            </Group>

                        </Stack>
                    </Paper>
                </Container>
            </Box>

            {/* Footer */}
            <Box py={24}>
                <Container>
                    <Text ta="center" size="sm" c="#777">
                        © {new Date().getFullYear()} RentalFlow · Smart Rentals Made Simple
                    </Text>
                </Container>
            </Box>
        </Box>
    );
}